import React, { Component } from "react";
import { Elements } from 'react-stripe-elements';
import Follow from "./Follow";

class FollowContainer extends Component {
    render() {
       return (
        <Elements>
          <Follow {...this.props}/>
        </Elements>
       )
    }
  }

export default FollowContainer;



// WEBPACK FOOTER //
// ./src/components/FollowContainer.js